const script = `
import BloctoIdo from 0xIDOADDRESS

access(all) fun main(name: String): {String: UFix64} {
    let activity = BloctoIdo.getActivity(name) ?? panic("activity doesn't exist")
    return activity.totalValidStake
}
`
export default script
